/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { MasterCategoryAndSeverityResItem } from '../models/master-category-and-severity-res-item';
import { StbDashboardDropdownExItem } from '../models/stb-dashboard-dropdown-ex-item';
import { StbDashboardQueryExReq } from '../models/stb-dashboard-query-ex-req';
import { StbDashboardResultExRes } from '../models/stb-dashboard-result-ex-res';

@Injectable({ providedIn: 'root' })
export class SustainableDashboardService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiSustainableDashboardQueryPost()` */
  static readonly ApiSustainableDashboardQueryPostPath = '/api/sustainable/dashboard/query';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSustainableDashboardQueryPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiSustainableDashboardQueryPost$Response(
    params?: {
      body?: StbDashboardQueryExReq
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<StbDashboardResultExRes>> {
    const rb = new RequestBuilder(this.rootUrl, SustainableDashboardService.ApiSustainableDashboardQueryPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StbDashboardResultExRes>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiSustainableDashboardQueryPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiSustainableDashboardQueryPost(
    params?: {
      body?: StbDashboardQueryExReq
    },
    context?: HttpContext
  ): Observable<StbDashboardResultExRes> {
    return this.apiSustainableDashboardQueryPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<StbDashboardResultExRes>): StbDashboardResultExRes => r.body)
    );
  }

  /** Path part for operation `apiSustainableDashboardMasterCategorySeverityContainPost()` */
  static readonly ApiSustainableDashboardMasterCategorySeverityContainPostPath = '/api/sustainable/dashboard/master-category-severity-contain';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSustainableDashboardMasterCategorySeverityContainPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSustainableDashboardMasterCategorySeverityContainPost$Response(
    params?: {
      containText?: string;
      max?: number;
      workGroupList?: Array<number>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<MasterCategoryAndSeverityResItem>>> {
    const rb = new RequestBuilder(this.rootUrl, SustainableDashboardService.ApiSustainableDashboardMasterCategorySeverityContainPostPath, 'post');
    if (params) {
      rb.query('containText', params.containText, {});
      rb.query('max', params.max, {});
      rb.query('workGroupList', params.workGroupList, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<MasterCategoryAndSeverityResItem>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiSustainableDashboardMasterCategorySeverityContainPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSustainableDashboardMasterCategorySeverityContainPost(
    params?: {
      containText?: string;
      max?: number;
      workGroupList?: Array<number>;
    },
    context?: HttpContext
  ): Observable<Array<MasterCategoryAndSeverityResItem>> {
    return this.apiSustainableDashboardMasterCategorySeverityContainPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<MasterCategoryAndSeverityResItem>>): Array<MasterCategoryAndSeverityResItem> => r.body)
    );
  }

  /** Path part for operation `apiSustainableDashboardDdlListGet()` */
  static readonly ApiSustainableDashboardDdlListGetPath = '/api/sustainable/dashboard/ddl-list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSustainableDashboardDdlListGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSustainableDashboardDdlListGet$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<StbDashboardDropdownExItem>> {
    const rb = new RequestBuilder(this.rootUrl, SustainableDashboardService.ApiSustainableDashboardDdlListGetPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StbDashboardDropdownExItem>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiSustainableDashboardDdlListGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSustainableDashboardDdlListGet(
    params?: {
    },
    context?: HttpContext
  ): Observable<StbDashboardDropdownExItem> {
    return this.apiSustainableDashboardDdlListGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<StbDashboardDropdownExItem>): StbDashboardDropdownExItem => r.body)
    );
  }

}
